<template>
  <div>
    <b-form-group
      label="Role Name"
      label-for="newRoleName"
    >
      <b-form-input
        id="newRoleName"
        v-model="roleName"
        autocomplete="off"
        placeholder="Enter a role name"
      />
    </b-form-group>
    <roles-form
      is-new
      :new-role-name="roleName"
    />
  </div>
</template>

<script>
import {
  BFormInput, BFormGroup,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import RolesForm from './RolesForm.vue'
import store from '@/store'
import roleStoreModule from '@/views/users/roles/roleStoreModule'

export default {
  components: {
    RolesForm,
    BFormInput,
    BFormGroup,
  },
  setup() {
    // Register Role Module
    const ROLE_APP_STORE_MODULE_NAME = 'roles'

    // Register module
    if (!store.hasModule(ROLE_APP_STORE_MODULE_NAME)) {
      store.registerModule(ROLE_APP_STORE_MODULE_NAME, roleStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ROLE_APP_STORE_MODULE_NAME)) store.unregisterModule(ROLE_APP_STORE_MODULE_NAME)
    })

    const roleName = ref('')

    return {
      roleName,
    }
  },
}
</script>

<style>

</style>
